import React from "react";
import Column from "@amzn/meridian/column";
import Text from "@amzn/meridian/text";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";
import Heading from "@amzn/meridian/heading";
import { MobileDisplay } from "./common/MobileDisplay";
import { useDeviceLayout } from "./common/context/DeviceLayoutContext";
/**
 * Returns the page heading and description
 * @param head
 * @param headAlt
 * @param desc
 * @param descAlt
 * @return JSX.Element
 */
const PageHeader = ({ tab, tabAlt, head, headAlt, desc, descAlt }) => {
  const { spacingInset_shorthand2 } = useDeviceLayout();

  return (
    <Column spacingInset={spacingInset_shorthand2} spacing={"none"}>
      <MobileDisplay visibility={true}>
        {tab && tabAlt ? (
          <Text type={"h100"} spacingTop={"medium"} color={"secondary"}>
            <FormattedMessage id={tab} defaultMessage={tabAlt} />
          </Text>
        ) : null}
      </MobileDisplay>
      <Heading level={2} type="h400" alignment="left">
        <FormattedMessage id={head} defaultMessage={headAlt} />
      </Heading>
      <MobileDisplay visibility={false}>
        {desc && descAlt ? (
          <Text color={"secondary"}>
            <FormattedMessage id={desc} defaultMessage={descAlt} />
          </Text>
        ) : null}
      </MobileDisplay>
    </Column>
  );
};

PageHeader.propTypes = {
  head: PropTypes.string,
  headAlt: PropTypes.string,
  desc: PropTypes.string,
  descAlt: PropTypes.string,
};

export default PageHeader;



// WEBPACK FOOTER //
// ./src/components/PageHeader.js